module.exports = __webpack_public_path__ + "joe.jpg?6e05ef418acb743e8594eb0925979f54";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pics/joe.jpg
// module id = 413
// module chunks = 0